import { Typography } from '@mui/material'
import React from 'react'
import './style.css'

// import category1 from '../../../assets/categories/category1.png'

const imageUrl = process.env.REACT_APP_BASH_IMG_URL


function Category({ item }) {
    return (
        <div className='mainDiv'>
            <img src={item?.image} alt={item?.name} className='imageCategory' />
            <Typography variant='h5' sx={{ mt: 2 }}>{item?.name}</Typography>
        </div>
    )
}

export default Category